interface BrandProps {
  compact?: boolean;
  onClick?: () => void;
}

export function Brand({ compact = false, onClick }: BrandProps) {
  const content = (
    <>
      <span className="brand__sigil">
        <span className="brand__nucleus" aria-hidden="true">
          <i />
          <i />
        </span>
        <span className="brand__orbit" aria-hidden="true" />
      </span>
      <span className="brand__text">
        <span className="brand__eyebrow">Parchís del Nexo</span>
        <span className="brand__name">Reino de Tableros</span>
      </span>
    </>
  );

  if (onClick) {
    return (
      <button type="button" className={`brand ${compact ? 'brand--compact' : ''}`} onClick={onClick}>
        {content}
      </button>
    );
  }
  return <div className={`brand ${compact ? 'brand--compact' : ''}`}>{content}</div>;
}
